<template>
  <transition name='fade'>
    <loading v-if='isloading'></loading>
  </transition>
</template>
<script>
import bus from '@/utils/bus';
import loading from '@/components/Loading.vue';

export default {
  name: 'skeelo',
  components: {
    loading
  },
  data() {
    return {
      isloading: true
    };
  },
  mounted() {
    this.isloading = true;
    bus.$emit('loading', true);
    window.location.href = 'https://skeelo.onelink.me/NOU2/amfru1fl';
    this.isloading = false;
  }
};
</script>